import { createContext, useContext } from "react";

/**
 * Carries the `useAddressAutocomplete` hook output so the
 * `Autocomplete{Street,City,State,Zip}Field` wrappers can wire shadows,
 * refs, and per-field blur without the consumer threading every prop by
 * hand. Set by `AddressAutocompleteRoot value={...}`.
 *
 * Consumers can still wrap parts of the hook output before passing it in —
 * context just forwards.
 */
const AutocompleteContext = createContext(null);

export const AutocompleteProvider = AutocompleteContext.Provider;

export const useAutocompleteContext = () => {
  const ctx = useContext(AutocompleteContext);
  if (!ctx) {
    throw new Error(
      "useAutocompleteContext must be used inside <AddressAutocompleteRoot value={...}>"
    );
  }
  return ctx;
};
